import { render, staticRenderFns } from "./FeedView.vue?vue&type=template&id=5a432080&scoped=true&"
import script from "./FeedView.vue?vue&type=script&lang=js&"
export * from "./FeedView.vue?vue&type=script&lang=js&"
import style0 from "./FeedView.vue?vue&type=style&index=0&id=5a432080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a432080",
  null
  
)

export default component.exports